export { VpMediaViewList } from './VpMediaViewList';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpMediaViewList/index.js